import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { CONSTANTES } from '../../shared/constanst/url-scrolls-header';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  params: any = {
    responseType: 'text',
    withCredentials: true
  };
  currentUser: any = null;

  constructor(private http: HttpClient) {} 

  obtenerTodosUsuarios(): Observable<any> {
    
    return this.http.get
    (
      `${CONSTANTES.URL_PRODUCCION}/admin/usuarios`, 
      this.params
    ).pipe(
      tap(response => {
      })
    );
  }

  isAuthenticated(): boolean {
    return !!this.currentUser;
  }

  hasRole(role: string): boolean {
    const user = JSON.parse(this.currentUser);
    return user?.roles?.includes(role);
  }
}
